import { render, staticRenderFns } from "./ModalUpdateProfile.vue?vue&type=template&id=b0cc7bfa"
import script from "./ModalUpdateProfile.vue?vue&type=script&lang=js"
export * from "./ModalUpdateProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports